import { render, staticRenderFns } from "./abnormal-history.vue?vue&type=template&id=a3ce98a0&scoped=true&"
import script from "./abnormal-history.vue?vue&type=script&lang=js&"
export * from "./abnormal-history.vue?vue&type=script&lang=js&"
import style0 from "./abnormal-history.vue?vue&type=style&index=0&id=a3ce98a0&scoped=true&lang=css&"
import style1 from "./abnormal-history.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ce98a0",
  null
  
)

export default component.exports